import Modal from './Modal'
import Input from './Input'
import SelectInput from './SelectInput'
import { useTranslation } from 'react-i18next'
import { GetTodos, GetUsers } from '../graphql/queries'
import { useApolloClient, useMutation, useQuery } from '@apollo/client'
import { CreateTodo } from '../graphql/mutations'
import { useEffect, useState } from 'react'
import Button from './Button'
import { TodoStatuses } from '../util/const'
import DateInput from './DateInput'
import Textarea from './Textarea'

const AddTodoModal = ({
    show,
    close,
    selectedStatus,
}) => {
    const { t } = useTranslation()
    const { data: usersData } = useQuery(GetUsers)
    
    const users = usersData?.getUsers?.map((user) => ({
        value: user.ID,
        label: user.RNAME,
    })) || []

    const apolloClient = useApolloClient()

    const [createTodo, { loading}] = useMutation(CreateTodo)

    const [fields, setFields] = useState({
        TITLE: '',
        DESCRIPTION: '',
        DUE_DATE: '',
        STATUS: '',
        ASSIGNEE_ID: '',
    })

    const [errors, setErrors] = useState({
        TITLE: null,
    })

    useEffect(() => {
        setFields({
            ...fields,
            STATUS: selectedStatus,
        })
    }, [selectedStatus, show])

    const setField = (field, value) => {
        setErrors({
            ...errors,
            [field]: null,
        })

        setFields({
            ...fields,
            [field]: value,
        })
    }

    const handleAdd = async () => {
        try {
            if (!fields.TITLE) {
                setErrors({
                    ...errors,
                    TITLE: t('Pealkiri on nõutud'),
                })
                return
            }

            const { data } = await createTodo({
                variables: {
                    data: {
                        ...fields,
                        ASSIGNEE_ID: fields?.ASSIGNEE_ID ? parseInt(fields?.ASSIGNEE_ID) : undefined,
                        STATUS: fields?.STATUS? parseInt(fields?.STATUS) : undefined,
                    },
                },
            })

            if (!data?.createTodo?.ID) {
                throw new Error('Failed to create todo')
            }

            apolloClient.refetchQueries({
                include: [GetTodos],
            })
            close()
        } catch (err) {
            console.log('handleAdd error', err)
        }
    }

    return (
        <Modal
            show={show}
            close={close}
            title={t('Lisa uus ülesanne')}
        >
            <div className='add-todo-modal-content'>
                <Input
                    label={t('Pealkiri')}
                    value={fields.TITLE}
                    onChange={(e) => setField('TITLE', e.target.value)}
                    error={errors.TITLE}
                />
                <Textarea
                    label={t('Kirjeldus')}
                    value={fields.DESCRIPTION}
                    onChange={(e) => setField('DESCRIPTION', e.target.value)}
                />
                <DateInput
                    label={t('Tähtaeg')}
                    value={fields.DUE_DATE ? new Date(fields.DUE_DATE) : null}
                    onChange={(val) => {
                        const localeString = val.toLocaleString('en')
                        setField('DUE_DATE', localeString)
                    }}
                />
                <SelectInput
                    label={t('Staatus')}
                    value={TodoStatuses.find((status) => status.value === fields.STATUS)}
                    options={TodoStatuses}
                    onChange={(option) => setField('STATUS', option.value)}
                />
                <SelectInput
                    label={t('Vastutav')}
                    value={users?.getUsers?.find((user) => user.ID === fields.ASSIGNEE_ID)}
                    options={users}
                    onChange={(option) => setField('ASSIGNEE_ID', option.value)}
                />
                <Button
                    label={t('Lisa')}
                    onClick={handleAdd}
                    loading={loading}
                    disabled={loading}
                />
            </div>
        </Modal>
    )
}

export default AddTodoModal